import { safeDefine } from "../../registration/safe-define.js";
import { MuteButtonElement } from "../../ui/mute-button/element.js";
//#region src/define/ui/mute-button.ts
safeDefine(MuteButtonElement);
//#endregion
